"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FetchService = function () {
  function FetchService($http, $rootScope) {
    _classCallCheck(this, FetchService);

    if ($rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  _createClass(FetchService, [{
    key: "getCareType",
    value: function getCareType() {
      return this.$http.get("" + WEBSERVICEURL + "/dataagility/api/service.refcode/query?domain=CARE");
    }
  }]);

  return FetchService;
}();

var AuditsbymonthController = function AuditsbymonthController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, $rootScope, $location, FunctionService) {
  _classCallCheck(this, AuditsbymonthController);

  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
  this.datatableApi;
  this.user = User.getUser();
  this.name = "Total Audits by Month";
  this.episodeValue = "";
  this.specialtyString = "";
  this.separationString = "";
  this.yearTypeOptions = ["Financial Year", "Calendar Year"];
  this.finYearOptions = [];
  this.calYearOptions = [];
  this.yearOptions = [];
  this.year = {
    selectedFy: undefined,
    yearTypeSelected: undefined
  };

  this.caretypeOptions = [];
  this.caretype = {
    selectedCaretype: []
  };
  this.allCareTypeOptions = [];

  this.patientClassOptions = [];
  this.patientClass = {
    selectedPatientClass: []
  };
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];
  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = {};
  this.url = WEBSERVICEURL + "/dataagility/api/service.totalauditsbymonth/query?";
  this.initUrl = "";

  Constants.getDivisionAndSpecialtyData().then(function (response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty(response.specialties);
    // Can load divisions if needed??
  });

  Constants.patientClassificationData().then(function successCallback(response) {
    $scope.vm.patientClassOptions = response;
  });

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;

    $scope.vm.functionSettings = response.functionSettings;

    // All Private Clients should be active, All Public should be inactive
    if ($scope.vm.episodeValue === "$") {
      console.log("WIES vars set to private");
      $scope.vm.wiesDefault = "0.00";
      $scope.vm.wiesParseAmount = 2;
    } else {
      console.log("WIES vars set to public");
      $scope.vm.wiesDefault = "0.0000";
      $scope.vm.wiesParseAmount = 4;
    }

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
    });
    var selectedYearType = response.functionSettings.CalendarOrFinancialYearReporting && response.functionSettings.CalendarOrFinancialYearReporting.valueString ? response.functionSettings.CalendarOrFinancialYearReporting.valueString : "Financial";
    $scope.vm.year.yearTypeSelected = selectedYearType + " Year";
    var startDate = "";
    var endDate = "";
    if (selectedYearType === "Calendar") {
      $scope.vm.yearOptions = $scope.vm.calYearOptions;
      $scope.vm.year.selectedFy = $scope.vm.calYearOptions[0];
      startDate = "01/01/" + moment().format("YYYY");
      endDate = "31/12/" + moment().format("YYYY");
    } else {
      $scope.vm.yearOptions = $scope.vm.finYearOptions;
      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[1];
      startDate = "01/07/" + $scope.vm.year.selectedFy.substring(0, 4);
      endDate = "30/06/" + $scope.vm.year.selectedFy.substring(7);
    }
    $scope.vm.initUrl = $scope.vm.url + "startDate=" + startDate + "&endDate=" + endDate + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientClass.selectedPatientClass) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "";
    $scope.vm.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
      headers: {
        Authorization: "Bearer " + $rootScope.globals.currentUser.token
      },
      url: $scope.vm.initUrl,
      type: "GET",
      error: function error(xhr, _error, thrown) {
        if (thrown == "Unauthorized") {
          //window.location.replace(window.location.origin + '/login');
          console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
        }
      }
    }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true)
    // .withOption('serverSide', true)
    .withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("initComplete", $scope.initCallback).withOption("rowCallback", function (row, data, index) {
      // Update column headers if data returned
      setDtHeaders($("#auditTable").DataTable());
    }).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
      extend: "print",
      text: ""
    }, {
      extend: "csvHtml5",
      text: "",
      filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
    }, {
      extend: "excelHtml5",
      text: "",
      filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
    }, {
      text: "",
      action: function action(e, dt, node, config) {
        dt.ajax.reload();
      }
    }]).withColumnFilter({
      //sPlaceHolder: "head:after",
      aoColumns: [{ type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
    });
  });

  function initFY() {
    var year = moment().format("YYYY");

    for (var i = 0; i < 2; i++) {
      $scope.vm.finYearOptions.push(year + " - " + (Number(year) + 1));
      year--;
    }

    // Default to current financial year
    if (moment().month() < 6) {
      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[1];
    } else {
      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[0];
    }

    $scope.vm.yearOptions = $scope.vm.finYearOptions;
  }

  function initCalendarYearOptions() {
    var year = moment().format("YYYY");
    for (var i = 0; i < 10; i++) {
      $scope.vm.calYearOptions.push(year);
      year--;
    }
  }

  initFY();
  initCalendarYearOptions();

  this.locale = "en-au";

  // callback functions
  this.selectCallback = selectCallback;
  this.setYearType = setYearType;
  this.filterPatientClass = filterPatientClass;
  this.filterCaretype = filterCaretype;

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // make sure DataTables doesn't sort month names alphabetically
    $.fn.dataTable.moment("MMMM");

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  this.dtOptions = {};

  this.dtColumns = [DTColumnBuilder.newColumn("id").withTitle("ID").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("monthDischarged").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodes").withTitle("Total<br>Episodes").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesRequireAudit").withTitle("Total Episodes<br>Required for Audit").withOption("width", "5%").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageMeetCriteria").withTitle("Episodes that<br>Meet Criteria (%)").withOption("width", "5%").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesAudited").withTitle("Total<br>Episodes Audited").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("coderQueries").withTitle("Coder<br>Queries").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("allOtherAudits").withTitle("All Other<br>Audits").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageAudited").withTitle("Total<br>Episodes Audited (%)").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed(2) + '%' : '0.00%';
  }), DTColumnBuilder.newColumn("percentageToBeAudited").withTitle("Episodes<br>to be Audited (%)").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed(2) + '%' : '0.00%';
  }), DTColumnBuilder.newColumn("totalCodingChange").withTitle("Total Episodes<br>With Coding Changes").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalDRGChange").withTitle("Total Episodes<br>with DRG Change ").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("WIESPerEpisode").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return full.totalEpisodes > 0 ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("sumTotalWIESChange").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return full.totalEpisodes > 0 ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("totalFinalWies").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return full.totalEpisodes > 0 ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("targetWIES").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return full.totalEpisodes > 0 && data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("WIESDifference").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return full.totalEpisodes > 0 && data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("WIESDifferencePercentage").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed(2) + '%' : '0.00%';
  })];

  // Search filters
  this.locale = "en-au";

  function setDtHeaders(table) {
    $(table.column(getIndexOfColumn("monthDischarged")).header()).html($scope.vm.separationString + "<br>Month");
    $(table.column(getIndexOfColumn("WIESPerEpisode")).header()).html($scope.vm.episodeValue + " Per Episode ");
    $(table.column(getIndexOfColumn("sumTotalWIESChange")).header()).html("Total<br>" + $scope.vm.episodeValue + " Change");
    $(table.column(getIndexOfColumn("totalFinalWies")).header()).html("Total " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn("targetWIES")).header()).html("Target " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn("WIESDifference")).header()).html($scope.vm.episodeValue + " Difference");
    $(table.column(getIndexOfColumn("WIESDifferencePercentage")).header()).html($scope.vm.episodeValue + " Difference (%)");
  }

  function getIndexOfColumn(columnName) {
    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === columnName;
    });
    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  function checkParamCare(param) {
    var codes = [];

    if (param.length !== 0) {
      angular.forEach(param, function (value, key) {
        codes.push(value.code);
      });

      return encodeURIComponent(codes.join());
    } else {
      return "";
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === "add") {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  this.filterCampus = filterCampus;

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case "specialty":
        if (thisModifier === "add") {
          filterSpecialty("add");
        } else {
          filterSpecialty("minus");
        }

        break;

      default:
        break;
    }
  }

  $scope.reload = function () {
    if ($scope.vm.datatableApi) {
      var startDayMonth = "";
      var endDayMonth = "";
      var startYear = "";
      var endYear = "";
      if ($scope.vm.year.yearTypeSelected === "Financial Year") {
        startDayMonth = "01/07/";
        endDayMonth = "30/06/";
        startYear = $scope.vm.year.selectedFy.substring(0, 4);
        endYear = $scope.vm.year.selectedFy.substring(7);
      } else {
        startDayMonth = "01/01/";
        endDayMonth = "31/12/";
        startYear = $scope.vm.year.selectedFy;
        endYear = $scope.vm.year.selectedFy;
      }
      var campus = "";
      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
          campus = $scope.vm.user.campus;
        } else {
          campus = $scope.vm.campus.selectedCampus;
        }
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
      var newUrl = $scope.vm.url + "startDate=" + startDayMonth + startYear + "&endDate=" + endDayMonth + endYear + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientClass.selectedPatientClass) + "&campus=" + encodeURIComponent(campus) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "";

      $scope.vm.dateRange = startDayMonth + startYear + " - " + endDayMonth + endYear;
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    }
  };

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    auditTable.search("").draw();

    filterSpecialty("minus");

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.reload();
    });
  }

  $scope.getCareType = function () {
    new FetchService($http, $scope).getCareType().then(function successCallback(response) {
      angular.forEach(response.data, function (value, key) {
        $scope.vm.caretypeOptions.push(value);

        if (value.description === "Acute inc Qual Newborn") $scope.vm.caretype.selectedCaretype.push($scope.vm.caretypeOptions[key]);
      });
    }, function errorCallback(response) {
      // $scope.feedback = "Error loading data";
      if (response.status === 401) {
        window.location.replace(window.location.origin + "/login?logout=true");
      }
    });
  };

  $scope.getCareType();

  function selectCallback(_newValue, _oldValue) {
    $scope.reload();
  }

  // Format year value from select list
  function setYearType(newValue, oldValue) {
    if (newValue === "Financial Year") {
      $scope.vm.yearOptions = $scope.vm.finYearOptions;
      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[1];
    } else {
      $scope.vm.yearOptions = $scope.vm.calYearOptions;
      $scope.vm.year.selectedFy = $scope.vm.calYearOptions[0];
    }

    $scope.reload();
  }

  function filterCaretype(swap) {
    $scope.vm.caretype.selectedCaretype = [];

    if (swap !== "minus") {
      angular.forEach($scope.vm.caretypeOptions, function (value, key) {
        $scope.vm.caretype.selectedCaretype.push(value);
      });
    }
  }

  function filterPatientClass(swap) {
    $scope.vm.patientClass.selectedPatientClass = [];

    if (swap !== "minus") {
      $scope.vm.patientClass.selectedPatientClass = $scope.vm.patientClassOptions;
    }
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }
};

exports.default = AuditsbymonthController;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditsbymonth/auditsbymonth.controller.js